/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { log } from 'src/consoleManager';
import postBeacon from 'src/networkManager';
import { getKeyNameStoreData, updateStoreData } from 'src/storage';
import { getAppSessionId, secondsToDays, getNextDateTime } from 'src/utils';
import { SESSION_KEY_STORAGE_TYPE, SESSION_STORAGE_TYPE } from 'src/utils/enum';
import { getSDKConfig } from 'src/utils/config';
let batchMaxRetriesCount = 3; // Number of retries for priority events from
let batchRemainingRetriesCount = 3;
let batchRetryBackoff = 500; // Retry delay in milliseconds (2 second)
let batchDiscardOnFailure = false; // Do not discard priority events if retries fail
let batchInterval = 10000; // Interval for batching events in seconds (5 minutes)`
let batchMaxBeaconsPerMinute = 120; // Maximum number of beacons allowed per minute
let batchOfflineCacheFlushInterval = 7; //Flush offline cache every 7 days in seconds

const withOutLocalStoreBatchedProcessQueue = () => {
  if (
    window.spnGlobalConfig.spnBeaconNetworkStatus &&
    window.spnGlobalConfig.batchedBeaconExecutionStart == false
  ) {
    batchConfigUpdate();
    withOutLocalStoreBatchedExecuteLocalStorage();
  }
};

const batchConfigUpdate = () => {
  const sdkConfig = getSDKConfig();
  batchMaxRetriesCount = sdkConfig?.batch?.max_retries || 3;
  batchRemainingRetriesCount = sdkConfig?.batch?.max_retries || 3;
  batchRetryBackoff = 500;
  batchDiscardOnFailure = sdkConfig?.batch?.discard_on_failure || false;
  batchInterval = 10000;
  const OfflineDays = sdkConfig.batch?.offline_cache_flush_interval || 604800;
  const finalDays = secondsToDays(OfflineDays);
  batchOfflineCacheFlushInterval = OfflineDays;
  batchMaxBeaconsPerMinute =
    sdkConfig?.general?.rate_limit?.max_beacons_per_minute || 120;
  if (sdkConfig?.general?.rate_limit?.enabled == true) {
    const burstLimit = sdkConfig?.general?.rate_limit?.burst_limit || 50;
    batchMaxBeaconsPerMinute += burstLimit;
  }
  batchRemainingRetriesCount -= 1;
};

// current storage Execution
const withOutLocalStoreBatchedExecuteLocalStorage = () => {
  try {
    if (
      window.spnGlobalConfig?.maxRecordPerMinute >= batchMaxBeaconsPerMinute
    ) {
      window.spnGlobalConfig.batchedBeaconExecutionStart = true;
      return;
    }
    if (!window.spnGlobalConfig.spnBeaconNetworkStatus) {
      return;
    }
    if (window.spnGlobalConfig.batchedBeaconExecutionStart) {
      return;
    }
    const sessionId = SESSION_STORAGE_TYPE.batched + getAppSessionId();

    if (window.spnGlobalConfig.batchStoreRecordData.length == 0) {
      window.spnGlobalConfig.batchedBeaconExecutionStart = true;
      return;
    }

    const currentTime = parseInt(
      window.spnGlobalConfig.batchStoreRecordData[0].currentTime
    );
    const payLoadBody =
      window.spnGlobalConfig.batchStoreRecordData[0].payLoadBody;
    const eventType = window.spnGlobalConfig.batchStoreRecordData[0].eventType;
    const offlineCacheNextDate = getNextDateTime(
      currentTime,
      batchOfflineCacheFlushInterval
    );
    // offline cache time calculate
    if (currentTime > offlineCacheNextDate) {
      // remove from queue when current time greater then offline time
      const apiResponse = 200;
      batchedCleanCurrentSessionBeacons(apiResponse, sessionId);
      batchedHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
    } else {
      const networkPromise = postBeacon(payLoadBody, eventType);
      networkPromise
        .then((apiResponse) => {
          batchedCleanCurrentSessionBeacons(apiResponse, sessionId);
          batchedHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
        })
        .catch((e) => {
          log(e);
          if (
            window.spnGlobalConfig.spnBeaconNetworkStatus ||
            window?.navigator?.onLine
          ) {
            const apiResponse = 0;
            batchedCleanCurrentSessionBeacons(apiResponse, sessionId);
            batchedHandleCurrentSessionNextBeaconExecute(
              apiResponse,
              sessionId
            );
            //window.spnGlobalConfig.batchedBeaconExecutionStart = true;
          }
        });
    }
  } catch (e) {
    log(e);
    window.spnGlobalConfig.batchedBeaconExecutionStart = true;
  }
};

const batchedCleanCurrentSessionBeacons = (apiResponse, sessionId) => {
  try {
    //apiResponse == 200 || apiResponse == 0 &&
    const removeFromQueue = getBatchRecordRemoveStatus(apiResponse);
    if (removeFromQueue) {
      if (window.spnGlobalConfig.batchStoreRecordData.length > 0) {
        window.spnGlobalConfig.batchStoreRecordData.shift();
      }
    }
  } catch (error) {
    log(error);
  }
};

const batchedHandleCurrentSessionNextBeaconExecute = (
  apiResponse,
  sessionId
) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      window.spnGlobalConfig.maxRecordPerMinute += 1;
      let intervalTime = 3000;
      // when beacons pass
      if (
        window.spnGlobalConfig.batchStoreRecordData.length > 0 &&
        window.spnGlobalConfig.batchedBeaconExecutionStart == false
      ) {
        setTimeout(() => {
          withOutLocalStoreBatchedExecuteLocalStorage();
        }, intervalTime);
      } else {
        window.spnGlobalConfig.batchedBeaconExecutionStart = true;
      }
    }
  } catch (error) {
    log(error);
  }
};

const getBatchRecordRemoveStatus = (apiResponse) => {
  let removeFromQueue = false;
  if (apiResponse == 0 && batchRemainingRetriesCount > 0) {
    removeFromQueue = false;
    batchRemainingRetriesCount -= 1;
  } else {
    removeFromQueue = true;
    batchRemainingRetriesCount = batchMaxRetriesCount - 1;
  }
  if (apiResponse == 200) {
    removeFromQueue = true;
    batchRemainingRetriesCount = batchMaxRetriesCount - 1;
  }
  if (batchDiscardOnFailure) {
    removeFromQueue = true;
  }
  return removeFromQueue;
};

export {
  withOutLocalStoreBatchedProcessQueue,
  withOutLocalStoreBatchedExecuteLocalStorage,
};
